import {
  ACCOUNT_TYPE,
  APPLICATION_TYPE,
} from '../../../constants/sessionStorage';
import {
  removeFromSessionStorage,
  storeInSessionStorage,
} from '../../../util/helpers/sessionStorageHelper';
import {
  APPLICATION_ONBOARDING_SETUP_ERROR,
  APPLICATION_ONBOARDING_SETUP_SUCCESS,
  APPLICATION_TYPE_SETUP_ERROR,
  APPLICATION_TYPE_SETUP_SUCCESS,
  GET_APPLICATION_ERROR,
  GET_APPLICATION_SUCCESS,
  DELETE_APPLICATION_SUCCESS,
  DELETE_APPLICATION_ERROR,
  RESET_APPLICATION,
  CREATE_APPLICATION_STEP_SUCCESS,
  CREATE_APPLICATION_STEP_ERROR,
  CREATE_APPLICATION_SUCCESS,
  CREATE_APPLICATION_ERROR,
} from '../../actions/application/applicationActionConstants';
import {
  SALES_ASSISTED_APPLICATIONS_ERROR,
  SALES_ASSISTED_APPLICATIONS_SUCCESS,
} from '../../actions/salesAssisted/salesAssistedActionContants';

import createReducer from '../../utils/createReducer';

const initialState = {
  Application: {},
  ApplicationOnboarding: {
    ApplicationOnboardingMenu: [],
    ApplicationOnboardingStep: {},
  },
  SelectedApplicationTypes: {
    ApplicationType: '',
    AccountType: '',
  },
  ApplicationStep: {},
  SalesAssistedApplications: {},
  error: '',
};

export default createReducer(
  {
    [APPLICATION_TYPE_SETUP_SUCCESS]: applicationTypeSetup,
    [APPLICATION_TYPE_SETUP_ERROR]: applicationTypeSetupError,
    [CREATE_APPLICATION_SUCCESS]: applicationCreateSuccess,
    [CREATE_APPLICATION_ERROR]: applicationCreateError,
    [APPLICATION_TYPE_SETUP_ERROR]: applicationTypeSetupError,
    [APPLICATION_ONBOARDING_SETUP_SUCCESS]: applicationOnboardingSetup,
    [APPLICATION_ONBOARDING_SETUP_ERROR]: applicationOnboardingSetupError,
    [GET_APPLICATION_SUCCESS]: getApplicationSuccess,
    [GET_APPLICATION_ERROR]: getApplicationError,
    [DELETE_APPLICATION_SUCCESS]: deleteApplicationSuccess,
    [DELETE_APPLICATION_ERROR]: deleteApplicationError,
    [RESET_APPLICATION]: resetApplication,
    [CREATE_APPLICATION_STEP_SUCCESS]: createApplicationStep,
    [CREATE_APPLICATION_STEP_ERROR]: createApplicationStepError,
    [SALES_ASSISTED_APPLICATIONS_SUCCESS]: fetchApplications,
    [SALES_ASSISTED_APPLICATIONS_ERROR]: fetchApplicationsError,
  },
  initialState,
);

function applicationTypeSetup(state, { payload }) {
  removeFromSessionStorage(APPLICATION_TYPE);
  removeFromSessionStorage(ACCOUNT_TYPE);

  if (payload?.ApplicationType) {
    storeInSessionStorage(APPLICATION_TYPE, payload?.ApplicationType);
  }

  if (payload?.AccountType) {
    storeInSessionStorage(ACCOUNT_TYPE, payload?.AccountType);
  }

  return {
    ...state,
    SelectedApplicationTypes: {
      ...state.SelectedApplicationTypes,
      ...payload,
    },
    error: '',
  };
}

function applicationTypeSetupError(state, { payload }) {
  return {
    ...state,
    SelectedApplicationTypes: {
      ...state.SelectedApplicationTypes,
    },
    error: payload,
  };
}

function applicationCreateSuccess(state, { payload }) {
  removeFromSessionStorage(APPLICATION_TYPE);
  removeFromSessionStorage(ACCOUNT_TYPE);

  if (payload?.ApplicationType) {
    storeInSessionStorage(APPLICATION_TYPE, payload?.ApplicationType);
  }

  if (payload?.AccountType) {
    storeInSessionStorage(ACCOUNT_TYPE, payload?.AccountType);
  }

  return {
    ...state,
    Application: {
      ...state.Application,
      ...payload,
    },
    error: '',
  };
}

function applicationCreateError(state, { payload }) {
  return {
    ...state,
    Application: {
      ...state.Application,
    },
    error: payload,
  };
}

function applicationOnboardingSetup(state, { payload }) {
  return {
    ...state,
    ApplicationOnboarding: {
      ...state.ApplicationOnboarding,
      ...payload,
    },
    error: '',
  };
}

function applicationOnboardingSetupError(state, { payload }) {
  return {
    ...state,
    ApplicationOnboarding: {
      ...state.ApplicationOnboarding,
    },
    error: payload,
  };
}

function getApplicationSuccess(state, { payload }) {
  return {
    ...state,
    Application: {
      ...state.Application,
      ...payload,
    },
    error: '',
  };
}

function getApplicationError(state, { payload }) {
  return {
    ...state,
    Application: {
      ...state.Application,
    },
    error: payload,
  };
}

function deleteApplicationSuccess(state, { payload }) {
  return {
    ...state,
    Application: payload,
    error: '',
  };
}

function deleteApplicationError(state, { payload }) {
  return {
    ...state,
    Application: {
      ...state.Application,
    },
    error: payload,
  };
}

function resetApplication() {
  return {
    Application: {},
    ApplicationOnboarding: {
      ApplicationOnboardingMenu: [],
      ApplicationOnboardingStep: {},
    },
    SelectedApplicationTypes: {
      ApplicationType: '',
      AccountType: '',
    },
    error: '',
  };
}

function createApplicationStep(state, { payload }) {
  return {
    ...state,
    ApplicationStep: payload,
    error: '',
  };
}

function createApplicationStepError(state, { payload }) {
  return {
    ...state,
    ApplicationStep: {
      ...state.ApplicationStep,
    },
    error: payload,
  };
}

function fetchApplications(state, { payload }) {
  return {
    ...state,
    SalesAssistedApplications: payload,
  };
}

function fetchApplicationsError(state, { payload }) {
  return {
    ...state,
    errorMessage: payload,
  };
}
